import React from "react";
import { shouldRenderDiv } from "../buyingGuideHelpers";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";
import BuyingGuideTable from "./BuyingGuideTable";

export default function BuyingGuideTableGrouping({
  section,
}: {
  section: BuyingGuideSection;
}) {
  return (
    <div className="guide-section">
      <div className="tab-content">
        {shouldRenderDiv(section.heading) && (
          <div
            className="item-header"
            dangerouslySetInnerHTML={{
              __html: section.heading,
            }}
          />
        )}
        <ul className="nav nav-pills">
          {section.children.map((current, index) => (
            <li
              className={index === 0 ? "active" : ""}
              key={`tbl-button-${index}`}
            >
              <a href={`#tab-${section.id}-${index}`} data-toggle="tab">
                {current.heading}
              </a>
            </li>
          ))}
        </ul>
        {section.children.map((current, index) => (
          <div
            className={`tab-pane ${index === 0 ? "active" : ""}`}
            id={`tab-${section.id}-${index}`}
            key={`tbl-${index}`}
          >
            <p className="header-3">{current.heading}</p>
            <BuyingGuideTable
              enableHeading={false}
              section={current}
              defaultHeaderTag=""
            />
          </div>
        ))}
      </div>
    </div>
  );
}
